/** Opaque, the way a card reads in our own conversation surface: one shell for every card in
 *  the thread, so corners, border and text colour agree across them. */
export const CHAT_CARD_SHELL =
  'rounded-lg border border-border bg-card text-card-foreground shadow-sm';
